
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {Loader2, AlertCircle} from 'lucide-react'
import { lumi } from '../lib/lumi'

const DashboardResolver = () => {
  const navigate = useNavigate()
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    const resolveDashboard = async () => {
      try {
        // Wait a moment for auth to settle
        await new Promise(resolve => setTimeout(resolve, 500))

        const user = lumi.auth.user

        if (!user) {
          setError(true)
          setErrorMessage('You are not signed in. Please sign in to access your dashboard.')
          return
        }

        // Resolve dashboard based on role
        const role = user.userRole

        if (role === 'superadmin') {
          navigate('/dashboard/superadmin', { replace: true })
        } else if (role === 'admin') {
          navigate('/dashboard/admin', { replace: true })
        } else if (role === 'recruiter') {
          navigate('/dashboard/recruiter', { replace: true })
        } else if (role === 'affiliate') {
          navigate('/dashboard/affiliate', { replace: true })
        } else if (role === 'nurse' || !role) {
          navigate('/dashboard/nurse', { replace: true })
        } else {
          setError(true)
          setErrorMessage('Your role is not recognized. Please contact support.')
        }
      } catch (err) {
        console.error('Dashboard resolver error:', err)
        setError(true)
        setErrorMessage('An unexpected error occurred. Please try again.')
      }
    }

    resolveDashboard()
  }, [navigate])

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
          <div className="flex items-center gap-3 mb-4">
            <AlertCircle className="h-6 w-6 text-red-500" />
            <h2 className="text-xl font-bold text-gray-900">Dashboard Access Error</h2>
          </div>
          <p className="text-gray-600 mb-6">{errorMessage}</p>
          <div className="flex gap-3">
            <button
              onClick={() => navigate('/auth')}
              className="flex-1 bg-primary-teal text-white px-4 py-2 rounded-lg font-medium hover:bg-teal-700 transition-colors"
            >
              Sign In
            </button>
            <button
              onClick={() => navigate('/contact')}
              className="flex-1 bg-gray-200 text-gray-700 px-4 py-2 rounded-lg font-medium hover:bg-gray-300 transition-colors"
            >
              Contact Support
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 text-primary-teal animate-spin mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Loading your dashboard…</h2>
        <p className="text-gray-600">Please wait while we redirect you.</p>
      </div>
    </div>
  )
}

export default DashboardResolver
